import { render } from "./courseComment.vue?vue&type=template&id=41ebdfbf&scoped=true"
import script from "./courseComment.vue?vue&type=script&lang=js"
export * from "./courseComment.vue?vue&type=script&lang=js"

import "./courseComment.vue?vue&type=style&index=0&id=41ebdfbf&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ebdfbf"]])

export default __exports__